import http, { url } from '../../http'

const API_URL = "accident_frequency_report"

class medicionFrecuenciaAPI {

  async save(resource) {
    const response = await http(`${API_URL}/save`, 'POST', resource)
    return response
  }

  async getAll(id) {
    const response = await http(`${API_URL}/index/${id}`, 'POST')
    return response
  }

  async getAllS(id, page, search) {
    const response = await http(`accident_frequency_report/index/${id}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async saveY(resource) {
    const response = await http(`${API_URL}/report`, 'POST', resource)
    return response
  }

  async saveM(resource) {
    const response = await http(`${API_URL}/report/month`, 'POST', resource)
    return response
  }

  async saveYears(resource) {
    const response = await http(`${API_URL}/between_years`, 'POST', resource)
    return response
  }

  async show(id) {
    const response = await http(`${API_URL}/show/${id}`)
    return response
  }



  /*   async getAll(page) {
      const response = await http(`${API_URL}?page=${page}`)
      return response
    } 
   */
/*   async getAll(id, page, search) {
    const response = await http(`${API_URL}/index/${id}?page=${page}&search=${search}`, 'POST')
    return response
  } */

  /*   async getAll(id, page) {
      const response = await http(`${API_URL}/companies/${id}?page=${page}`)
      return response
    }  */

  async get(id) {
    const response = await http(`${API_URL}/index/${id}`, 'POST')
    return response
  }
  /* 
    async getExcel(id) {
      const response = url(`${API_URL}/excelAdvance/${id}`)
      return response
    }  */

  async getExcel(companyId, year) {
    let user = JSON.parse(localStorage.getItem('user'))

    if (user.token) {
      return url(`${API_URL}/exportExcel/${companyId}/${year}?&access_token=${user.token}`)
    }


    /*     let user = JSON.parse(localStorage.getItem('user'))
      const response = url(`${API_URL}/excelAdvance/${id}`, {
        access_token: user.token,
      }) */
  }


  async getShow(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async update(id, resource) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', resource)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

}

export default new medicionFrecuenciaAPI()